module.exports = __webpack_public_path__ + "static/media/49pic.d8b90421.jpg";